import styled from 'styled-components'

import LiveSelect from 'live/components/forms/ui/select'

export const BowtieListContainer = styled.div`
    position: relative;
    width: 100%;
    height: 100%;

    .Select-menu {
        &::-webkit-scrollbar {
            width: 6px;
        }

        &::-webkit-scrollbar-thumb {
            background: var(--gray-600);
            border-radius: 10px;
        }
    }


    .custom-list-column-topEvent {
        word-break: break-all;
    }

    .first-row-container {
        display: flex;
        margin: 32px 0;
        .export-import-button {
            padding: 6px;
            height: 36px;
            width: 130px;
            margin-left: 10px;
            background: var(--gray-0);
            border-radius: 3px;
        }
    }
    .no-outline-button {
        &:focus {
            outline: none;
        }
    }
    .no-bowtie {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        margin-top: 64px;

        p {
            padding-top: 5px;
            color: var(--gray-700);
            font-size: 13px;
        }

        i {
            color: var(--gray-500);
            font-size: 24px;
        }

        a {
            color: var(--blue-500);
            font-size: 13px;
        }
    }

    .filter-dropdown-toggle {
        display: flex;
        align-items: center;
        justify-content: center;
        margin-left: 8px;

        .dropdown {
            height: 100%;

            .dropdown-toggle {
                background: transparent;
                border-color: var(--gray-400);
                border-radius: 3px;
                box-shadow: none;
                margin-left: 0;
                height: 100%;
            }
        }
    }

    .loading-spin {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        margin-top: 64px;

        p {
            padding-top: 5px;
            color: var(--gray-700);
            font-size: 13px;
        }

        i {
            color: var(--gray-500);
            font-size: 24px;
        }
    }

    .custom-list {
        .custom-list-column-id,
        .custom-list-column-bowtieCode,
        .custom-list-column-asset,
        .custom-list-column-operation {
            width: 50px;
            white-space: nowrap;
        }

        .custom-list-column-actions {
            width: 74px;
        }
    }
`

export const StyledButton = styled(LiveSelect)``

export const ImportBody = styled.div`
    font-size: 14px;
    .importLabel {
        margin-top: 8px;
        font-size: 16px;
        cursor: pointer;
        .file-input {
            display: none;
        }
    }
`
